import { render, staticRenderFns } from "./TextPathProperties.vue?vue&type=template&id=452b8e9d&scoped=true"
import script from "./TextPathProperties.vue?vue&type=script&setup=true&lang=ts"
export * from "./TextPathProperties.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TextPathProperties.vue?vue&type=style&index=0&id=452b8e9d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452b8e9d",
  null
  
)

export default component.exports